"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReplaceSubscriptionEvent = exports.Name = void 0;
const Name = exports.Name = 'replace-subscription';
const ReplaceSubscriptionEvent = exports.ReplaceSubscriptionEvent = Name;
